import React, { useState } from 'react'

import { WALKTHROUGH_STEP } from '@/components/flows/WalkthroughFlow/constants'
import { useWalkthroughSteps } from '@/components/flows/WalkthroughFlow/hooks/useWalkthroughSteps'
import thumbnailImageUrl from '@/components/flows/WalkthroughFlow/steps/1_IntroducingRq/thumbnail.png'
import VimeoEmbed from '@/components/misc/VideoEmbed'
import { useIsMinWidthLg } from '@/hooks/useIsMinWidthLg'
import { useIsMinWidthMd } from '@/hooks/useIsMinWidthMd'

const IntroducingRq: React.FC = () => {
  const { currentStep } = useWalkthroughSteps()
  const [isPlayingVideo, setIsPlayingVideo] = useState(false)
  const isMinWidthMd = useIsMinWidthMd()
  const isMinWidthLg = useIsMinWidthLg()

  function getVideoHeight() {
    if (isMinWidthLg) {
      return 460
    }

    if (isMinWidthMd) {
      return 400
    }

    return 300
  }

  // Don't play the video if the user proceeds to another step
  const shouldPlayVideo =
    currentStep.key === WALKTHROUGH_STEP.introducingRq && isPlayingVideo

  if (isPlayingVideo) {
    return (
      <VimeoEmbed
        videoUrl="https://player.vimeo.com/video/1016079540"
        height={getVideoHeight()}
        autoplay={shouldPlayVideo}
      />
    )
  }

  return (
    <img
      src={thumbnailImageUrl}
      alt="Introducing RQ"
      className="hover-dim max-w-full cursor-pointer"
      onClick={() => setIsPlayingVideo(true)}
    />
  )
}

export default IntroducingRq
